/**
 * normalizes strings
 * @example normalize('© 2020 Rául');
 * @returns {String} a normalized string
 */
function normalize() {
  for (var _len = arguments.length, strings = new Array(_len), _key = 0; _key < _len; _key++) {
    strings[_key] = arguments[_key];
  }
  var str = strings.join('');

  // noinspection NonAsciiCharacters
  var replaceChars = {
    '‘': '\'',
    // left single quotation mark
    '’': '\'',
    // right single quotation mark
    '“': '"',
    // left double quotation mark
    '”': '"' // right double quotation mark
  };
  var encodedChars = {
    // Reserved characters
    '&': '&amp;',
    // ampersand [MUST BE FIRST IN THE LIST!]
    '<': '&lt;',
    // less than
    '>': '&gt;',
    // greater than
    '©': '&copy;',
    // copyright
    '®': '&reg;',
    // registered trademark
    '™': '&trade;',
    // trade mark
    // Spanish characters
    Á: '&Aacute;',
    á: '&aacute;',
    É: '&Eacute;',
    é: '&eacute;',
    Í: '&Iacute;',
    í: '&iacute;',
    Ó: '&Oacute;',
    ó: '&oacute;',
    Ú: '&Uacute;',
    ú: '&uacute;',
    Ü: '&Uuml;',
    ü: '&uuml;',
    Ñ: '&Ntilde;',
    ñ: '&ntilde;',
    '¿': '&iquest;',
    '¡': '&iexcl;'
  };
  var isURL = function isURL(string) {
    var regexp = new RegExp('^http(s?):', 'i'); // does the string begin with http: or https:?
    return regexp.test(string);
  };
  var decodeStr = function decodeStr(string) {
    // remove all entities and start from clean content
    var regexString = '';
    Object.keys(replaceChars).forEach(function (k) {
      var regex = new RegExp(k, 'g');
      regexString = string.replace(regex, replaceChars[k]);
    });
    Object.keys(encodedChars).forEach(function (k) {
      var regex = new RegExp(encodedChars[k], 'g');
      regexString = string.replace(regex, k);
    });
    return regexString;
  };
  var encodeStr = function encodeStr(string) {
    // replace all non-alphabetic characters with HTML entity
    var regexString = '';
    Object.keys(encodedChars).forEach(function (k) {
      var regex = new RegExp(k, 'g');
      regexString = string.replace(regex, encodedChars[k]);
    });
    return regexString;
  };
  if (str !== undefined) {
    str = decodeStr(str);
    if (!isURL(str)) {
      str = encodeStr(str); // convert all required characters to entities
    }
  } else {
    str = '';
  }
  return str;
}
export { normalize as default };